import { render, staticRenderFns } from "./EstimatesOldPageTaskItemPriceModal.vue?vue&type=template&id=467c8007&"
import script from "./EstimatesOldPageTaskItemPriceModal.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPageTaskItemPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports